import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";

export const itemColdefs = [
    {
        field: "drawingNo",
        headerName: "Drawing no",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "materialType",
        headerName: "Item type",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "itemName",
        headerName: "Item details",
        minWidth: window.innerWidth * 0.2,
        flex: 1.5,
        filter: true,
    },
    {
        field: "quantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "rate",
        headerName: "Rate",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "actualRate",
        headerName: "Actual rate",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "amount",
        headerName: "Amount",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "discount",
        headerName: "Discount",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "chargesAmt",
        headerName: "Extra charges",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "total",
        headerName: "Taxable Amt",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "sgst",
        headerName: "SGST",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "sgstAmount",
        headerName: "SGST Amt",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "cgst",
        headerName: "CGST",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "cgstAmount",
        headerName: "CGST Amt",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "igst",
        headerName: "IGST",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "igstAmount",
        headerName: "IGST Amt",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "netTotal",
        headerName: "Net total",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "remarks",
        headerName: "Remarks",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "startDate",
        headerName: "Start date",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "endDate",
        headerName: "End date",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },

];
export const inquiryColdefs = [
    {
        headerCheckboxSelection: true,
        checkboxSelection: true,
        width: 50,
        pinned: 'left',
        suppressSizeToFit: true
    },
    {
        field: "inquiryNo",
        headerName: "Inquitry no",
        minWidth: window.innerWidth * 0.06,
        flex: 0.8,
        filter: true,
    },
    {
        field: "inquiryDate",
        headerName: "Inquiry date",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },

];
export const productColdefs = [
    {
        field: "idItem",
        headerName: "ID item",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "drawingNo",
        headerName: "Drawing No",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "itemType",
        headerName: "Item type",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "itemName",
        headerName: "Item name",
        minWidth: window.innerWidth * 0.15,
        flex: 1.5,
        filter: true,
    },
    {
        field: "quantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },

];

export const vendorPriceColdefs = [
    {
        field: "purchaseRate",
        headerName: "Purchase Rate",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "partyACName",
        headerName: "Party AC Name",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "actualRate",
        headerName: "Actual Rate",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "rate",
        headerName: "Rate",
        minWidth: window.innerWidth * 0.15,
        flex: 1.5,
        filter: true,
    },
    {
        field: "idItem",
        headerName: "ID Item1",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },

];

export const PurchaseOrderPopup = (props) => {
    return (
        <ModalBasic
            id="purchase-order"
            classParams="!w-[90%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            {!props.open && (
                <div className='input-fields p-[30px]'>
                    <span className="text-blue text-[16px] font-semibold">Purchase order details</span>
                    <div className='item-grp grid grid-cols-6 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                        <div className='input-grp'>
                            <label>P.O. no</label>
                            <TextInput type='text'
                                id='poNo' name='poNo'
                                value={props.purchaseObject.poNo}
                                handleChange={(event) => props.handleChangeForWork(event, 'poNo')}
                                className={props.validState?.error?.poNo !== undefined ? "error" : ""}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>PO date</label>
                            <TextInput type='date'
                                id='poDate' name='poDate'
                                value={props.purchaseObject.poDate}
                                handleChange={(event) => props.handleChangeForWork(event, 'poDate')}
                                className={props.validState?.error?.poDate !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>P.O. type</label>
                            <MultiSelectDropdown
                                drpIdentity="Select type"
                                options={props.purchaseObject.typeList}
                                value={props.purchaseObject.idType ? props.purchaseObject.typeList.find(x => x.value === props.purchaseObject.idType) : 0}
                                onChange={(event) =>
                                    props.handleChangeForDropdown(event, "idType")
                                }
                            />

                        </div>
                        <div className='input-grp'>
                            <label>Mode of delivery</label>
                            <TextInput type='text'
                                id='modeOfDelivery' name='modeOfDelivery'
                                value={props.purchaseObject.modeOfDelivery}
                                handleChange={(event) => props.handleChangeForWork(event, 'modeOfDelivery')}
                                className={props.validState?.error?.modeOfDelivery !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp col-span-2'>
                            <label>Auth. employee</label>
                            {/* <MultiSelectDropdown
                                drpIdentity="Select employee"
                                options={props.purchaseObject.employeeList}
                                value={props.purchaseObject.idEmployee ? props.purchaseObject.employeeList.find(x => x.value === props.purchaseObject.idEmployee) : 0}
                                onChange={(event) =>
                                    props.handleChangeForDropdown(event, "idEmployee")
                                }
                                className={props.validState?.error?.idEmployee !== undefined ? "error" : ""}
                            /> */}
                            <TextInput type='text'
                                id='usp_Users' name='usp_Users'
                                value={props.usp_Users.find(x => x.globalUserID === props.globalUserID)?.userName || ''}
                                disabled={true}
                            />
                        </div>
                        <div className='input-grp col-span-2'>
                            <label>Select vendor</label>
                            <MultiSelectDropdown
                                drpIdentity="Select vendor"
                                options={props.purchaseObject.vendorList}
                                value={props.purchaseObject.idVendor ? props.purchaseObject.vendorList.find(x => x.value === props.purchaseObject.idVendor) : 0}
                                onChange={(event) =>
                                    props.handleChangeForDropdown(event, "idVendor")
                                }
                                className={props.validState?.error?.idVendor !== undefined ? "error" : ""}
                            />

                        </div>
                        <div className='input-grp'>
                            <label>P.O. from</label>
                            <MultiSelectDropdown
                                drpIdentity="Select WO from"
                                options={props.purchaseObject.poFromList}
                                value={props.purchaseObject.idPoFrom ? props.purchaseObject.poFromList.find(x => x.value === props.purchaseObject.idPoFrom) : 0}
                                onChange={(event) =>
                                    props.handleChangeForDropdown(event, "idPoFrom")
                                }
                            />

                        </div>
                        <div className='input-grp'>
                            <label>Mode of payment</label>
                            <TextInput type='text'
                                id='modeOfPayment' name='modeOfPayment'
                                value={props.purchaseObject.modeOfPayment}
                                handleChange={(event) => props.handleChangeForWork(event, 'modeOfPayment')}
                                className={props.validState?.error?.modeOfPayment !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>P.O. validity</label>
                            <TextInput type='text'
                                id='validity' name='validity'
                                value={props.purchaseObject.validity}
                                handleChange={(event) => props.handleChangeForWork(event, 'validity')}
                                className={props.validState?.error?.validity !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Payment terms</label>
                            <TextInput type='text'
                                id='paymentTerms' name='paymentTerms'
                                value={props.purchaseObject.paymentTerms}
                                handleChange={(event) => props.handleChangeForWork(event, 'paymentTerms')}
                                className={props.validState?.error?.paymentTerms !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-outer grid grid-cols-6 gap-2.5 col-span-6'>
                            <div className='input-grp row-span-2 col-span-2'>
                                <label>Address</label>
                                <textarea rows={3}
                                    id='address' name='address'
                                    value={props.purchaseObject.address}
                                    onChange={(event) => props.handleChangeForWork(event, 'address')}
                                    className={`h-full ${props.validState?.error?.address !== undefined ? "error" : ""}`}
                                />
                            </div>

                            <div className='input-grp'>
                                <label>Delivery date</label>
                                <TextInput type='date'
                                    id='deliveryDate' name='deliveryDate'
                                    value={props.purchaseObject.deliveryDate}
                                    handleChange={(event) => props.handleChangeForWork(event, 'deliveryDate')}
                                    className={props.validState?.error?.deliveryDate !== undefined ? "error" : ""}
                                />
                            </div>
                            <div className='input-grp !inline-flex !gap-[10px] items-center'>
                                <input type='CheckBox'
                                    className='shadow-none w-[15px] h-[15px]'
                                    id='isClose' name='isClose'
                                    value={props.purchaseObject.isClose}
                                    checked={props.purchaseObject.isClose}
                                    onClick={(event) => props.handleChangeForWork(event, 'isClose')}
                                />
                                <label>Close purchase order?</label>
                            </div>
                            {/* <button
                                className="save-btn btns py-[10px] px-[20px] col-start-3" onClick={() => props.addPI()}>Add PI items
                            </button> */}
                            {props.purchaseObject.idPurchaseOrder > 0 ?
                                <div className='btn-grp flex items-center gap-2.5 col-start-3 col-span-4'>
                                    <button
                                        className="save-btn btns py-[10px] px-[20px] " onClick={() => props.generatePurchaseOrderInvoice('Invoice')}>Download Invoice
                                    </button>
                                    <button
                                        className="save-btn btns py-[10px] px-[20px] " onClick={() => props.generatePendingPurchaseOrderInvoice('Invoice')}>Download Pending     Invoice
                                    </button>

                                    <button
                                        className="save-btn btns py-[10px] px-[20px] " onClick={() => props.shareOnWhatsApp()}>Share On WhatsApp
                                    </button>

                                    <button
                                        className="save-btn btns py-[10px] px-[20px] " onClick={() => props.sendOnEmail()}>Send Email
                                    </button>

                                    <button
                                        className="save-btn btns py-[10px] px-[20px] " onClick={() => props.generatePurchaseOrderInvoice('WeightSlip')}>Download Weight Slip
                                    </button>

                                </div>
                                : null}

                        </div>
                    </div>
                    <span className="text-blue text-[16px] font-semibold">Product details</span>
                    <div className='item-inner grid grid-cols-6 items-start gap-2.5 mt-2'>
                        <div className='input-grp'>
                            <label>Drawing no</label>
                            <TextInput type='text'
                                id='drawingNo' name='drawingNo'
                                value={props.productObject.drawingNo}
                                handleChange={(event) => props.handleChange(event, 'drawingNo')}
                                className={props.validState?.error?.drawingNo !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Select type</label>
                            <MultiSelectDropdown
                                drpIdentity="Select material type"
                                options={props.productObject.materialTypeList}
                                value={props.productObject.idMaterialType ? props.productObject.materialTypeList.find(x => x.value === props.productObject.idMaterialType) : 0}
                                onChange={(event) =>
                                    props.handleChangeForDropdownForProductObject(event, "idMaterialType")
                                }
                                className={props.validState?.error?.idMaterialType !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp col-span-2'>
                            <label>Item name</label>
                            {/* <MultiSelectDropdown
                                drpIdentity="Select item"
                                options={props.productObject.itemList}
                                value={props.productObject.idItem ? props.productObject.itemList.find(x => x.value === props.productObject.idItem) : 0}
                                onChange={(event) =>
                                    props.handleChangeForDropdownForProductObject(event, "idItem")
                                }
                                className={props.validState?.error?.idItem !== undefined ? "error" : ""}
                            /> */}
                            <TextInput
                                id="SelectItem"
                                name="SelectItem"
                                value={props.productObject.itemIdLabel}
                                handleOnClick={(event) => props.handleOnClick(event, "itemList")}
                            // className={props.validState?.error?.chequeBookSeries !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Unit</label>
                            <MultiSelectDropdown
                                drpIdentity="Select item"
                                options={props.productObject.unitList}
                                value={props.productObject.idUnit ? props.productObject.unitList.find(x => x.value === props.productObject.idUnit) : 0}
                                onChange={(event) =>
                                    props.handleChangeForDropdownForProductObject(event, "idUnit")
                                }
                                className={props.validState?.error?.idUnit !== undefined ? "error" : ""}
                                isDisabled={true}
                            />
                            {/* <TextInput type='text'
                                id='unit' name='unit'
                                value={props.productObject.unit}
                                handleChange={(event) => props.handleChange(event, 'unit')}
                                className={props.validState?.error?.unit !== undefined ? "error" : ""}
                                disabled
                            /> */}
                        </div>
                        <div className='input-grp'>
                            <label>Quantity</label>
                            <TextInput type='number'
                                id='quantity' name='quantity'
                                value={props.productObject.quantity}
                                handleChange={(event) => props.handleChange(event, 'quantity')}
                                className={props.validState?.error?.quantity !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Rate</label>
                            <TextInput type='number'
                                id='rate' name='rate'
                                value={props.productObject.rate}
                                handleChange={(event) => props.handleChange(event, 'rate')}
                                className={props.validState?.error?.rate !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Actual rate</label>
                            <TextInput type='number'
                                id='actualRate' name='actualRate'
                                value={props.productObject.actualRate}
                                handleChange={(event) => props.handleChange(event, 'actualRate')}
                                className={props.validState?.error?.actualRate !== undefined ? "error" : ""}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Amount</label>
                            <TextInput type='number'
                                id='amount' name='amount'
                                value={props.productObject.amount}
                                handleChange={(event) => props.handleChange(event, 'amount')}
                                className={props.validState?.error?.amount !== undefined ? "error" : ""}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Discount(%)</label>
                            <TextInput type='number'
                                id='discount' name='discount'
                                value={props.productObject.discount}
                                handleChange={(event) => props.handleChange(event, 'discount')}
                                className={props.validState?.error?.discount !== undefined ? "error" : ""}
                            //disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Charges amount</label>
                            <TextInput type='number'
                                id='chargesAmt' name='chargesAmt'
                                value={props.productObject.chargesAmt}
                                handleChange={(event) => props.handleChange(event, 'chargesAmt')}
                                className={props.validState?.error?.chargesAmt !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Total</label>
                            <TextInput type='number'
                                id='total' name='total'
                                value={props.productObject.total}
                                handleChange={(event) => props.handleChange(event, 'total')}
                                className={props.validState?.error?.total !== undefined ? "error" : ""}
                                disabled
                            />
                        </div>
                        <div className='input-grp col-span-2'>
                            <label>Tax group</label>
                            <MultiSelectDropdown
                                drpIdentity="Select tax"
                                options={props.productObject.taxList}
                                value={props.productObject.idTaxGroup ? props.productObject.taxList.find(x => x.value === props.productObject.idTaxGroup) : 0}
                                onChange={(event) =>
                                    props.handleChangeForDropdownForProductObject(event, "idTaxGroup")
                                }
                                className={props.validState?.error?.idTaxGroup !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>SGST {props.purchaseObject.idType === 1 && props.productObject.sgst > 0 ? `- ${props.productObject.sgst}%` : ""}</label>
                            <TextInput type='number'
                                id='sgstAmount' name='sgstAmount'
                                value={props.productObject.sgstAmount}
                                handleChange={(event) => props.handleChange(event, 'sgstAmount')}
                                className={props.validState?.error?.sgstAmount !== undefined ? "error" : ""}
                                disabled={true}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>CGST {props.purchaseObject.idType === 1 && props.productObject.cgst > 0 ? `- ${props.productObject.cgst}%` : ""}</label>
                            <TextInput type='number'
                                id='cgstAmount' name='cgstAmount'
                                value={props.productObject.cgstAmount}
                                handleChange={(event) => props.handleChange(event, 'cgstAmount')}
                                className={props.validState?.error?.cgstAmount !== undefined ? "error" : ""}
                                disabled={true}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>IGST {props.productObject.igst > 0 ? props.purchaseObject.idType === 1 ? "" : `-${props.productObject.igst}%` : ""}</label>
                            <TextInput type='number'
                                id='igstAmount' name='igstAmount'
                                value={props.productObject.igstAmount}
                                handleChange={(event) => props.handleChange(event, 'igstAmount')}
                                className={props.validState?.error?.igstAmount !== undefined ? "error" : ""}
                                disabled={true}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Net total</label>
                            <TextInput type='number'
                                id='netTotal' name='netTotal'
                                value={props.productObject.netTotal}
                                handleChange={(event) => props.handleChange(event, 'netTotal')}
                                className={props.validState?.error?.netTotal !== undefined ? "error" : ""}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Start date</label>
                            <TextInput type='date'
                                id='startDate' name='startDate'
                                value={props.productObject.startDate}
                                handleChange={(event) => props.handleChange(event, 'startDate')}
                                className={props.validState?.error?.startDate !== undefined ? "error" : ""}
                                disabled={true}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>End date</label>
                            <TextInput type='date'
                                id='endDate' name='endDate'
                                value={props.productObject.endDate}
                                handleChange={(event) => props.handleChange(event, 'endDate')}
                                className={props.validState?.error?.endDate !== undefined ? "error" : ""}
                                disabled={true}
                            />
                        </div>
                        <div className='input-grp col-span-2'>
                            <label>Remarks</label>
                            <TextInput type='text'
                                id='remarks' name='remarks'
                                value={props.productObject.remarks}
                                handleChange={(event) => props.handleChange(event, 'remarks')}
                                className={props.validState?.error?.remarks !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='btn-grp flex gap-2.5 mt-5'>
                            {props.productObject.keyId > 0 ?
                                <button
                                    className={`save-btn btns py-[10px] px-[20px] ${props.productObject.inwardStatus ? "disabled" : ""}`}
                                    onClick={() => props.insertItem("Update")}
                                    disabled={props.productObject.inwardStatus ? true : false}
                                >
                                    Update
                                </button>
                                :
                                <button className="save-btn btns py-[10px] px-[20px]" onClick={() => props.insertItem("Insert")}>Insert</button>
                            }

                            {props.productObject.keyId && props.productObject.keyId > 0 && props.productObject.keyId !== "" ?
                                <button
                                    className={`delete-btn btns py-[10px] px-[20px] ${props.productObject.inwardStatus ? "disabled" : ""}`}
                                    onClick={() => props.delete(props.productObject.keyId)}
                                    disabled={props.productObject.inwardStatus ? true : false}
                                >
                                    Delete
                                </button>
                                :
                                null
                            }
                            <button className="edit-btn btns py-[10px] px-[20px] " onClick={() => props.clear()}>Clear</button>
                        </div>
                    </div>
                    <div className="process-table h-[30vh] mt-5">
                        <div className="table-inner h-full">
                            <AgGridReact
                                rowData={props.itemRowData}
                                columnDefs={itemColdefs}
                                //onCellClicked={props.handleCellClickItemList}
                                overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                onRowDoubleClicked={props.onItemRowDataClicked}
                            />
                        </div>
                    </div>
                    <div className='total-amt mt-2.5 p-2.5 bg-[#3f8cff1a] rounded-[10px]'>
                        <span className="text-blue text-[16px] font-semibold">Amount details</span>
                        <div className='input-grp-outer grid grid-cols-8 gap-2.5 mt-2.5'>
                            <div className='input-grp'>
                                <label>Total quantity</label>
                                <TextInput type='number'
                                    id='totalQuantity' name='totalQuantity'
                                    value={props.purchaseObject.totalQuantity}
                                    handleChange={(event) => props.handleChangeForPayment(event, 'totalQuantity')}
                                    disabled
                                />
                            </div>
                            <div className='input-grp'>
                                <label>Total amount</label>
                                <TextInput type='number'
                                    id='totalAmt' name='totalAmt'
                                    value={props.purchaseObject.totalAmt}
                                    handleChange={(event) => props.handleChangeForPayment(event, 'totalAmt')}
                                    disabled
                                />
                            </div>
                            <div className='input-grp'>
                                <label>Extra charges</label>
                                <TextInput type='number'
                                    id='extraCharges' name='extraCharges'
                                    value={props.purchaseObject.extraCharges}
                                    handleChange={(event) => props.handleChangeForPayment(event, 'extraCharges')}
                                    disabled
                                />
                            </div>
                            <div className='input-grp'>
                                <label>Discount amount</label>
                                <TextInput type='number'
                                    id='totalDiscountAmt' name='totalDiscountAmt'
                                    value={props.purchaseObject.totalDiscountAmt}
                                    handleChange={(event) => props.handleChangeForPayment(event, 'totalDiscountAmt')}
                                    disabled
                                />
                            </div>
                            <div className='input-grp'>
                                <label>Taxable amount</label>
                                <TextInput type='number'
                                    id='taxableAmt' name='taxableAmt'
                                    value={props.purchaseObject.taxableAmt}
                                    handleChange={(event) => props.handleChangeForPayment(event, 'taxableAmt')}
                                    disabled
                                />
                            </div>
                            <div className='input-grp'>
                                <label>Tax amount</label>
                                <TextInput type='number'
                                    id='taxAmt' name='taxAmt'
                                    value={props.purchaseObject.taxAmt}
                                    handleChange={(event) => props.handleChangeForPayment(event, 'taxAmt')}
                                    disabled
                                />
                            </div>
                            <div className='input-grp'>
                                <label>Total with tax</label>
                                <TextInput type='number'
                                    id='totalwithTax' name='totalwithTax'
                                    value={props.purchaseObject.totalwithTax}
                                    //handleChange={(event) => props.handleChangeForPayment(event, 'totalwithTax')}
                                    disabled
                                />
                            </div>
                            <div className='input-grp'>
                                <label>TCS amount</label>
                                <div className='input-inner flex items-center gap-[4px]'>
                                    <TextInput type='number'
                                        id='tcsPercentage' name='tcsPercentage'
                                        value={props.purchaseObject.tcsPercentage}
                                        handleChange={(event) => props.handleChangeForPayment(event, 'tcsPercentage')}
                                        placeholder="%"
                                        className="w-[30%]"
                                    />
                                    <TextInput type='number'
                                        id='tcsAmt' name='tcsAmt'
                                        value={props.purchaseObject.tcsAmt}
                                        handleChange={(event) => props.handleChangeForPayment(event, 'tcsAmt')}
                                        placeholder="Amount"
                                        className="w-[70%]"
                                        disabled
                                    />
                                </div>
                            </div>
                            <div className='input-grp'>
                                <label>Adjustable amount</label>
                                <TextInput type='number'
                                    id='adjustableAmt' name='adjustableAmt'
                                    value={props.purchaseObject.adjustableAmt}
                                    handleChange={(event) => props.handleChangeForPayment(event, 'adjustableAmt')}
                                    className='font-semibold'
                                />
                            </div>
                            <div className='input-grp'>
                                <label>Final amount</label>
                                <TextInput type='number'
                                    id='finalAmt' name='finalAmt'
                                    value={props.purchaseObject.finalAmt}
                                    handleChange={(event) => props.handleChangeForPayment(event, 'finalAmt')}
                                    className='font-semibold'
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                    <div className='btn-grp flex gap-2.5 mt-5'>
                        <button className="update-btn btns" onClick={() => props.submit()} disabled={props.isSaving}>Save</button>
                        <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                    </div>
                </div>
            )}
            {props.open && (
                <div className='tables p-[30px]'>
                    <span className="text-blue text-[16px] font-semibold">Purchase order selection</span>
                    <div className="process-table h-[35vh] mt-[5px] mb-2 pb-[8px] border-b border-slate-200">
                        <div className="table-inner h-full">
                            <AgGridReact
                                rowData={props.firstPIList}
                                columnDefs={inquiryColdefs}
                                onCellClicked={props.handleCellClickfirstPIList}
                                rowSelection="multiple"
                                overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                onSelectionChanged={(event) => {
                                    const selectedRowsselectedRows = event.api.getSelectedRows();
                                    props.onSelectionChanged(selectedRowsselectedRows);
                                }}
                            />
                        </div>
                    </div>

                    <span className="text-blue text-[16px] font-semibold">Select Vendor</span>
                    <div className="process-table h-[35vh] mt-[5px]">
                        <div className="table-inner h-full">
                            <AgGridReact
                                rowData={props.secondPIList}
                                columnDefs={productColdefs}
                                onCellClicked={props.handleCellClickSecondPIList}
                                overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                            />
                        </div>
                    </div>

                    <span className="text-blue text-[16px] font-semibold">Vendor Price Details</span>
                    <div className="process-table h-[35vh] mt-[5px]">
                        <div className="table-inner h-full">
                            <AgGridReact
                                rowData={props.thirdPIList}
                                columnDefs={vendorPriceColdefs}
                                //onCellClicked={props.handleCellClickThirdPIList}
                                overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                            />
                        </div>
                    </div>

                    <div className='btn-grp flex gap-2.5 mt-5'>
                        <button className="update-btn btns" onClick={() => props.addProduct()}>Add products</button>
                        <button className="delete-btn btns" onClick={() => props.back()}>Back</button>
                    </div>
                </div>
            )}

        </ModalBasic>
    )
}